/*
  payments/pendingwithdrawals/index
 */
import actions from '../common/lib/utils/actions.js';
import fetchPendingWithdrawals from './lib/fetch-pending-withdrawals.js';
import pendingWithdrawals from './lib/pending-withdrawals.js';
import fetchCancelWithdraw from './lib/fetch-cancel-withdraw.js';
import view from './lib/view.js';

const conf = {
	pendingWithdrawalsUrl: '/PaymentFormDataService/getPendingWithdrawals?useDateFormat=true',
	cancelPendingWithdrawalsUrl: '/PaymentFormDataService/cancelWithdraw?id=',
	wrap: null,
	isEmptyCallback: null,
	origin: null
};

function initialization() {
	view.init(conf);
	pendingWithdrawals.init();
	fetchPendingWithdrawals.init(conf.pendingWithdrawalsUrl, conf.isEmptyCallback);
	fetchCancelWithdraw.init(conf.cancelPendingWithdrawalsUrl);
	actions.setupPendingWithdrawals();
}

export default {
	init(p) {
		conf.isEmptyCallback = (p.isEmptyCallback || null);
		conf.wrap = (p.wrapElmSelector || null);
		conf.origin = (p.origin || null);
		initialization();
	},
	close() {
		view.close();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/pendingwithdrawals/index.js